import type { ReactNode } from 'react';

export type RecruitTileProps = {
  onClick: () => void;
  children: ReactNode;
};

/** Empty-slot "+ recruit" tile shown after the filled polaroids. */
export const RecruitTile = ({ onClick, children }: RecruitTileProps) => (
  <button
    type="button"
    onClick={onClick}
    className="flex aspect-[4/5] w-full max-w-[130px] flex-col items-center justify-center rounded-[2px] border-2 border-cream/45 border-dashed px-1.5 py-2 text-cream/60 transition-colors hover:border-cream/80 hover:text-cream sm:max-w-[180px]"
  >
    <span className="font-display font-extrabold text-2xl leading-none">+</span>
    <span className="mt-1 font-display font-extrabold text-[9px] uppercase tracking-[0.18em]">
      {children}
    </span>
  </button>
);
